<template>
  <div id="page">
    <van-nav-bar
      title="我要入团"
      left-text=""
      left-arrow
      @click-left="onClickLeft()"
    >
    </van-nav-bar>
    <!--团队搜索-->
    <van-row>
      <!-- <div style="margin-top: 10px;width: 85%; float: left;">
        <van-search
          v-model="teamName"
          shape="round"
          background="#4fc08d"
          placeholder="请输入搜索关键词"
        />
      </div> -->
      <div style="margin-top: 10px; width: 80%; float: left;">
          <van-search v-model="teamName" placeholder="请输入搜索关键词" />
        </div>
        <div
          style="width: 15%; float: left; padding-top: 20px; margin-left: 10px;"
        >
          <van-button type="primary" size="small" @click="Search">确定</van-button>
        </div>
    </van-row>
    <!--团队未满列表-->
    <van-row>
      <div style="margin-top: 10px">
        <van-grid :gutter="10" :column-num="3" icon-size="2.5rem">
          <van-grid-item
            icon="user-circle-o"
            v-for="(item, idx) in list"
            v-bind:key="idx"
          >
            <div class="balance-text" slot="text">
              <div class="balance-name">
                {{ item.TeamName }}({{ item.TeamDetailsNum }})
              </div>
              <div class="balance-value">
                <van-button
                  round
                  type="danger"
                  size="mini"
                  @click="CreateApply(item.ID)"
                  >加入</van-button
                >
              </div>
            </div>
          </van-grid-item>
        </van-grid>
      </div>
    </van-row>
  </div>
</template>
<script>
import { NavBar, Row, GridItem, Grid, Search, Button, Dialog } from "vant";
export default {
  data() {
    return {
      teamName: "",
      list: [],
    };
  },
  created() {
    this.Search();
  },
  methods: {
    Search() {
      var that = this;
      that.$http
        .get("Team/QueryTeamList", {
          params: {
            teamName: that.teamName,
          },
        })
        .then((res) => {
          that.list = res.data.ListData;
        });
    },
    CreateApply(teamId) {
      var that = this;
      Dialog.confirm({
        title: "申请加入",
        message:
          "是否确认加入该团队?",
      })
        .then(() => {
          // on confirm
          that.$http
          .get("Team/CreateApply", {
            params: { teamId: teamId, type: 2 },
          })
          .then((res) => {
            if (res.data == "success") {
              that.$toast("加入团队申请已提交，请等待团长通过！");
              that.$router.back(-1);
            } else {
              that.$toast(res.data);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Search.name]: Search,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
  },
};
</script>
<style scoped>
html {
  background: #f12416;
}
#page {
  width: 100%;
  height: 100%;
}
.indexPage {
  width: 100%;
  height: 100%;
  background-image: url("../assets/draw3/index.jpg");

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-content: space-around;
  justify-content: center;
  flex-wrap: wrap;
}
.mockTap {
  width: 280px;
  height: 280px;
  padding-top: 70px;
}
.step {
  z-index: 999;
}

.bounce-in-top {
  -webkit-animation: bounce-in-top 1.2s ease-in both;
  animation: bounce-in-top 1.2s ease-in both;
}
/* ----------------------------------------------
 * Generated by Animista on 2021-9-5 1:36:2
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation bounce-in-top
 * ----------------------------------------
 */
@-webkit-keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
@keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}

.balance-text {
  margin-top: 0;
  font-size: 13px;
}
.balance-name {
  color: #666;
  margin-top: 5px;
}
.balance-value {
  font-size: 13px;
  font-weight: bold;
  margin-top: 5px;
  color: #b00;
  text-align: center;
}
</style>
